export const SET_CURRENT_VIEW_NAME = 'SET_CURRENT_VIEW_NAME';
export const SET_CURRENT_VIEW_LINK = 'SET_CURRENT_VIEW_LINK';
